export default __webpack_public_path__ + "static/media/champion_white.a993ecde.svg";